export const INVALID_PAGE_TEXT = `Password link is invalid.<br>Please, resubmit password reset!`
export const EXPIRED_PAGE_TEXT = `Password link is expired.<br>Please, resubmit password reset!`

export const TOKEN_INVALID_ERROR_KEY = '11'
export const TOKEN_NOT_EXISTS_ERROR_KEY = '86'
export const TOKEN_EXPIRED_ERROR_KEY = '88'